import Body from "../../../../../material/skeleton/Body";
import Footer from "../../../../../material/skeleton/Footer";
import {Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {CheckCircle, Delete} from "@mui/icons-material";
import {useEffect, useState} from "react";
import isNull from "../../../../../mixin/isNull";
import LoadingData from "../../emergency/step/common/LoadingData";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import useQuotationRepository from "../../../../../repository/insurance/useQuotationRepository";
import useQuotationItemRepository from "../../../../../repository/insurance/useQuotationItemRepository";
import StandardizedItemSelector from "../step/quotation/StandardizedItemSelector";
import useHelper from "../../../../../use/useHelper";
import parameter from "../../../../../enum/parameter";

export default function ({interventionId, orderId, onQuotationUpdated}) {
    const helper = useHelper();
    const quotationRepository = useQuotationRepository();
    const quotationItemRepository = useQuotationItemRepository();

    /** @type Quotation */
    const quotation = quotationRepository.findOneByInterventionId(interventionId).select();
    /** @type QuotationItem[] */
    const items = quotationItemRepository.findAllByIds(quotation?.getQuotationItemsId()).select();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        quotationRepository.findOneByInterventionId(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(quotation)) return;

        quotationItemRepository.findAllByIds(quotation.getQuotationItemsId()).exec();
    }, [quotation?.getId()]);

    const handleAdd = item => {
        quotationItemRepository.create({
            quotation_item: {
                name: item.name,
                pricing: item.pricing,
                quantity: item.quantity,
                quotation_id: quotation.getId()
            }
        });
    }

    const handleDelete = id => () => {
        quotationItemRepository.remove(id);
    }

    const handleTerminate = async () => {
        setLoading(true);
        onQuotationUpdated();
    }

    if (isNull(quotation) || isNull(items)) return <LoadingData/>;

    return (
        <>
            <Body sx={{pt: 1, pb: 2, px: 1}}>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Item</TableCell>
                            <TableCell>Qté</TableCell>
                            <TableCell>HT (€)</TableCell>
                            <TableCell/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            items.map((item, i) => (
                                <TableRow key={i}>
                                    <TableCell width={"60%"}>
                                        <Typography fontSize={"small"}>{item.getName()}</Typography>
                                    </TableCell>
                                    <TableCell width={"15%"}>{item.getQuantity()}</TableCell>
                                    <TableCell width={"20%"}>
                                        {helper.priceFormatter(item.getPricing() / 100)}
                                    </TableCell>
                                    <TableCell width={"5%"}>
                                        <IconButton
                                            size="small"
                                            color={"error"}
                                            onClick={handleDelete(item.getId())}
                                            data-test="insurance-button-delete-item"
                                        >
                                            <Delete fontSize="small"/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {
                            items.length === 0
                                ? (
                                    <TableRow>
                                        <TableCell colSpan={4}>
                                            <Typography textAlign="center" variant="caption">
                                                Aucun item pour le moment
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )
                                : null
                        }
                    </TableBody>
                </Table>
                <Box mt={4}>
                    <StandardizedItemSelector
                        key={JSON.stringify(items)}
                        orderId={orderId}
                        onSelect={handleAdd}
                        currentQuotationItems={items.map(i => ({name: i.getName()}))}
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    variant="contained"
                    size="small"
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    fullWidth
                    onClick={handleTerminate}
                    disabled={loading}
                    data-test="insurance-button-terminate-update-quotation"
                >
                    Modification terminée
                </Button>
            </Footer>
        </>
    );
}
